//#region src/models/demoPhoneFormat.ts
/**
* Browser-safe Demo phone helpers. The web app imports these without pulling
* in the database layer that stores the numbers.
*
* Demo numbers are typed into the control bar as free text, stamped onto
* patients, substituted into provider search results, and then compared
* against a dial target. Those layers only agree if they normalize the same
* way, so they all call this: last 10 digits, since the EHR, the control bar,
* and the phone providers disagree about country codes and punctuation.
*/
function normalizeDemoPhone(value) {
	return (value ?? "").replace(/\D/g, "").slice(-10);
}
/**
* A value must be 10 digits, or 11 with a leading US country code, after
* punctuation is stripped. Empty is not allowed. Longer strings would
* otherwise silently keep only the last 10. Save in the control bar and
* saveDemoControlPhones both use this.
*/
function isValidDemoPhoneInput(value) {
	const digits = (value ?? "").replace(/\D/g, "");
	if (digits.length === 10) return true;
	return digits.length === 11 && digits.startsWith("1");
}

//#endregion
export { isValidDemoPhoneInput, normalizeDemoPhone };